export default __webpack_public_path__ + "static/screeny-130-ga-4-a7c948ec5f3cf8bd9ba4e2072e2fb67d.jpg";